import React, { useState, useEffect, useRef } from "react";
import { FaTimes, FaGift, FaStar, FaChevronRight, FaChevronLeft } from "react-icons/fa";
import CONFIG from "../config";
import "./Foydalanuvchi.css";
import { useLocation } from "react-router-dom";

const ROTATION_TIME = 7000; // 7 seconds

export default function SpecialNotifCard({ notifs, onClose }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [progress, setProgress] = useState(0);
    const timerRef = useRef(null);
    const progressRef = useRef(null);
    const location = useLocation();

    const currentNotif = notifs && notifs.length > 0 ? notifs[currentIndex] : null;
    const isLast = currentIndex === (notifs ? notifs.length - 1 : 0);

    useEffect(() => {
        setIsVisible(true);
        startTimer();
        return () => {
            stopTimer();
        };
    }, []);

    const startTimer = () => {
        stopTimer();
        setProgress(0);

        const startTime = Date.now();
        progressRef.current = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const p = Math.min((elapsed / ROTATION_TIME) * 100, 100);
            setProgress(p);

            if (p >= 100) {
                stopTimer();
                handleNext();
            }
        }, 50);

        timerRef.current = setTimeout(() => {
            // handleNext(); // Already handled by progressRef interval for precision
        }, ROTATION_TIME);
    };

    const stopTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        if (progressRef.current) clearInterval(progressRef.current);
    };

    const handleNext = () => {
        if (currentIndex < notifs.length - 1) {
            setCurrentIndex(prev => prev + 1);
            startTimer();
        } else {
            // If it's the last one and it auto-rotates, we just let it stay 
            // OR we can close it. User said "oxirgisiga o'tganda tugmani bossa hammasini o'chirib qo'ysin".
            // So on the last one, we stop auto-rotation and wait for button.
            stopTimer();
            setProgress(100);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prev => prev - 1);
            startTimer();
        }
    };

    const handleAction = async () => {
        const token = localStorage.getItem("loyiha_token");

        // If it's the last one, mark ALL as read
        if (isLast) {
            try {
                // We'll mark all IDs in the current notifs list as read
                const markPromises = notifs.map(n =>
                    fetch(`${CONFIG.API_BASE_URL}/mark_notification_read.php?id=${n.id}`, {
                        method: 'POST',
                        headers: { 'Authorization': `Bearer ${token}` }
                    })
                );
                await Promise.all(markPromises);
            } catch (e) {
                console.error("Mark all read error:", e);
            }

            const allIds = notifs.map(n => n.id);
            setIsVisible(false);
            setTimeout(() => onClose(allIds), 500);
        } else {
            // Just move to next if not last
            handleNext();
        }
    };

    const handleClose = () => {
        // Just close without marking all as read, pass currently seen IDs to dismiss them for this session
        // However, the request says "X bosib chiqib ketganda... sahifani yangilaganda chiqsin".
        // So we just close the UI.
        const seenIds = notifs.map(n => n.id);
        setIsVisible(false);
        setTimeout(() => onClose(seenIds), 500);
    };

    // Hide on Landing Page (After all hooks)
    if (location.pathname === '/' || location.pathname === '') return null;

    if (!currentNotif) return null;

    return (
        <div className={`special-notif-overlay ${isVisible ? 'active' : ''}`}>
            <div className={`special-notif-card theme-${currentNotif.turi}`}>
                {/* Progress Bar */}
                <div className="special-notif-timer-bar">
                    <div className="special-notif-timer-fill" style={{ width: `${progress}%` }}></div>
                </div>

                <button className="special-notif-close" onClick={handleClose}>
                    <FaTimes />
                </button>

                <div className="special-notif-content">
                    {notifs.length > 1 && (
                        <div className="special-notif-nav">
                            <span className="notif-counter">{currentIndex + 1} / {notifs.length}</span>
                        </div>
                    )}

                    <div className="special-notif-icon-box">
                        {currentNotif.turi === 'gift' ? <FaGift className="notif-main-icon pulse" /> : <FaStar className="notif-main-icon pulse" />}
                    </div>

                    <div className="special-notif-image-box">
                        <img
                            src={`/Rasm/bildirishnoma/${currentNotif.rasm}`}
                            alt="Special"
                            className="special-notif-img"
                            onError={(e) => { e.target.src = '/Rasm/bildirishnoma/default.jpg' }}
                        />
                        <div className="special-notif-shine"></div>

                        {/* Navigation Buttons Inside Image Box */}
                        {notifs.length > 1 && (
                            <>
                                {currentIndex > 0 && (
                                    <button className="carousel-nav-btn prev" onClick={handlePrev}>
                                        <FaChevronLeft />
                                    </button>
                                )}
                                {currentIndex < notifs.length - 1 && (
                                    <button className="carousel-nav-btn next" onClick={handleNext}>
                                        <FaChevronRight />
                                    </button>
                                )}
                            </>
                        )}
                    </div>

                    <div className="special-notif-text">
                        <h2 className="special-notif-title">{currentNotif.nomi}</h2>
                        <div className="special-notif-divider"></div>
                        <p className="special-notif-desc">{currentNotif.matni}</p>
                    </div>

                    <div className="special-notif-actions">
                        <button className="special-notif-btn" onClick={handleAction}>
                            <span>{isLast ? "Rahmat / Tushunarli" : "Keyingisi"}</span>
                            {isLast ? <FaStar /> : <FaChevronRight />}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
}
